import { useQuery } from "@tanstack/react-query";

import { getShifts } from "@/services/shifts.service";

interface UseShiftsParams {
  from: string;
  to: string;
}

/**
 * Récupère les créneaux d'une semaine pour la pointeuse.
 * Cache court (1 min) car l'admin peut modifier le planning depuis le backoffice
 * et on veut que la pointeuse reflète le changement assez vite.
 */
export const useShifts = ({ from, to }: UseShiftsParams) => {
  return useQuery({
    queryKey: ["shifts", from, to],
    queryFn: () => getShifts({ from, to }),
    staleTime: 1000 * 60, // 1 min
    gcTime: 1000 * 60 * 60 * 24, // 24h pour offline
    networkMode: "offlineFirst",
  });
};
